import { render, staticRenderFns } from "./CategoryBtn.vue?vue&type=template&id=062effd2&scoped=true&"
import script from "./CategoryBtn.vue?vue&type=script&lang=js&"
export * from "./CategoryBtn.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBtn.vue?vue&type=style&index=0&id=062effd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062effd2",
  null
  
)

export default component.exports